import {
  Modal,
  message,
  Row,
  Col,
  Input,
  Spin,
  Button,
  Card,
  Space,
  Table,
  Popconfirm,
  Tag,
  Checkbox,
} from "antd";
import { useState } from "react";
import axios from "axios";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_CHECK_ADD_CANCEL_HAND,
  POST_LOAN_DB2,
  POST_PRE_INVESTIGATE,
} from "../../../API/apiUrls";
import {
  RestOutlined,
  SearchOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const AddInvestigate = ({ open, close, dataDefault, func }) => {
  const [loading, setLoading] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [searchInput, setSearchInput] = useState(null);
  const [checkboxUnLogic, setCheckboxUnLogic] = useState(false);

  console.log(dataDefault);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close();
  };

  const queryData = async () => {
    const q = (searchInput || "").trim();

    if (!q) {
      return message.warning("กรุณากรอกเลขที่สัญญา");
    }

    const normalized = await loadData(q);

    if (!normalized) return; // ถ้าไม่มีข้อมูลหรือมี error ให้หยุด
    console.log("normalized", normalized);

    // เช็คเงื่อนไข
    if (!checkboxUnLogic) {
      if (normalized.statusActiveInvestigate === 1) {
        return message.error(
          `อยู่ในรอบดำเนินการ ${dayjs(normalized.dateCeoInvestigate)
            .add(543, "year")
            .format("D MMM YY")}`
        );
      } else if (normalized.statusActiveInvestigate === 2) {
        return message.error(
          `อยู่ในรอบดำเนินการ ${dayjs(normalized.dateOnlineInvestigate)
            .add(543, "year")
            .format("D MMM YY")}`
        );
      } else if (normalized.statusActiveInvestigate === 3) {
        return message.error(
          `เจอทรัพย์ ${dayjs(normalized.responseDateInvestigate)
            .add(543, "year")
            .format("D MMM YY")}`
        );
      } else if (normalized.statusActiveInvestigate === 4) {
        return message.error(
          `ไม่เจอทรัพย์ ${dayjs(normalized.responseDateInvestigate)
            .add(543, "year")
            .format("D MMM YY")}`
        );
      }
    }

    // เพิ่มข้อมูลลงตาราง
    setArrayTable((prev) => {
      const keyOf = (x) => x.CONTNO ?? x.contno;
      const map = new Map(prev.map((x) => [keyOf(x), x]));
      map.set(normalized.CONTNO, normalized);
      return Array.from(map.values());
    });
  };

  const loadData = async (contno) => {
    setLoading(true);

    try {
      const res = await axios.post(
        POST_CHECK_ADD_CANCEL_HAND,
        { CONTNO: `${contno}` },
        { headers: HEADERS_EXPORT_BEN }
      );

      if (res.status !== 200) {
        message.error("ไม่มีข้อมูล");
        return null;
      }

      // เช็คสถานะพิเศษ
      if (res.data.success === "ปิดไปแล้ว") {
        message.warning("ปิดไปแล้ว");
        return null;
      }

      if (res.data.success === "ไม่พบสัญญา") {
        message.warning("ไม่พบสัญญา");
        return null;
      }

      return res.data; // Return ข้อมูลกลับไป
    } catch (error) {
      console.error("Error loading data:", error);
      const errorMsg =
        error.response?.data?.message || error.message || "ไม่พบข้อมูลสัญญา";
      message.error(`ไม่พบข้อมูล: ${errorMsg}`);
      return null;
    } finally {
      setLoading(false);
    }
  };
  const onChangeInputSearch = (data) => {
    setSearchInput(data);
  };

  const confirmDelete = (record) => {
    if (!record) {
      message.error("ไม่พบรายการที่จะลบ");
      return;
    }
    const contno = record.CONTNO ?? record.contno;
    if (!contno) {
      message.error("ไม่มีเลขที่สัญญาในรายการนี้");
      return;
    }

    // ลบทุกแถวที่มี CONTNO/contno ตรงกัน (กันเคสซ้ำ)
    setArrayTable((prev) =>
      prev.filter((row) => (row.CONTNO ?? row.contno) !== contno)
    );

    message.success(`ลบสัญญาเรียบร้อย: ${contno}`);
  };

  const cancelDelete = (e) => {
    console.log(e);
    message.error("ยกเลิกการลบสัญญา");
  };

  const getDataDB2 = async (payload) => {
    try {
      const res = await axios.post(POST_LOAN_DB2, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (res.status === 200) {
        if (!res.data) {
          message.error("สัญญาไม่ถูกต้อง โปรดตรวจสอบสัญญา");
          return null;
        }
        if (typeof res.data === "string") {
          // กรณีข้อความ error ที่มาเป็น string
          if (res.data.includes("Contract No. Not Found")) {
            message.error("ไม่พบเลขที่สัญญา");
            return null;
          }
          message.error(res.data);
          return null;
        }
        return Array.isArray(res.data) ? res.data : [res.data];
      }

      message.error("ดึงข้อมูลไม่สำเร็จ");
      return null;
    } catch (err) {
      console.error("loadDataReprint error:", err);
      message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
      return null;
    }
  };

  const heldelDataLoad = (rawData = []) => {
    const contnos = rawData
      .map((x) => String(x?.CONTNO ?? "").trim())
      .filter(Boolean); // กันค่าว่าง

    const formatted = contnos
      .map((v) => `'${v.replace(/'/g, "''")}'`)
      .join(",");
    return { CONTNO: formatted };
  };

  const handleOk = async () => {
    const dataUse = heldelDataLoad(arrayTable);
    console.log("dataUse", dataUse);
    const dataSend = (await getDataDB2(dataUse)) || [];
    console.log(dataSend);

    if (dataSend.length > 0) {
      insertData(dataSend);
    } else {
      message.warning("ไม่มีข้อมูล");
    }
  };

  const onChangeCheckbox = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setCheckboxUnLogic(e.target.checked);
  };

  const insertData = async (payload) => {
    setLoading(true);

    try {
      const res = await axios.post(
        BASE_URL_BEN + POST_PRE_INVESTIGATE,
        payload,
        {
          headers: HEADERS_EXPORT_BEN,
        }
      );
      if (res.status === 200) {
        message.success("บันทึกข้อมูลสำเร็จ");
      } else {
        message.error("บันทึกข้อมูลไม่สำเร็จ");
      }
    } catch (err) {
      const status = err?.response?.status;
      console.error("queryMultiData error:", err);

      message.error(
        `เกิดข้อผิดพลาดในการดึงข้อมูล${status ? ` (${status})` : ""}`
      );
    } finally {
      func(true);
      setLoading(false);
      handleCancel();
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "contract_no",
      key: "contract_no",
      align: "center",
      render: (text, record) => <>{record.CONTNO ? record.CONTNO : null}</>,
    },
    {
      title: "จ่ายล่าสุด",
      dataIndex: "LPAYD",
      key: "LPAYD",
      align: "center",
      render: (text, record) => (
        <>
          {record.LPAYD
            ? dayjs(record.LPAYD).add(543, "year").format("D MMM YY")
            : null}
        </>
      ),
    },
    {
      title: "สถานะ",
      align: "center",
      render: (text, record) => (
        <Tag color={"blue"}>
          {record.statusActiveInvestigate === 1
            ? "อยู่ในรอบส่งสืบแล้ว"
            : record.statusActiveInvestigate === 2
            ? "ส่งสืบแล้ว"
            : record.statusActiveInvestigate === 3
            ? "เจอทรัพย์"
            : record.statusActiveInvestigate === 4
            ? "ไม่เจอทรัพย์"
            : "ยังไม่สืบทรัพย์"}
          <br />
          {record.dateCancelContno
            ? dayjs(record.dateCancelContno).add(543, "year").format("D MMM YY")
            : record.datePre
            ? dayjs(record.datePre).add(543, "year").format("D MMM YY")
            : null}
        </Tag>
      ),
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (text, record) => (
        <>
          <Popconfirm
            title="ลบสัญญา"
            description="คุณต้องการลบสัญญานี้ใช่หรือไม่ ?"
            onConfirm={() => {
              confirmDelete(record);
            }}
            onCancel={cancelDelete}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <Button style={{ fontSize: "16px", color: "red" }}>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        <span style={{ fontSize: 16, fontWeight: 400, color: "#333" }}>
          เลือกสัญญาสืบทรัพย์
        </span>
      }
      open={open}
      onCancel={handleCancel}
      width={"auto"}
      keyboard={true}
      maskClosable={false}
      centered
      footer={[
        <Button
          danger
          key="cancel"
          onClick={handleCancel}
          style={{ color: "red" }}
        >
          ปิด
        </Button>,
        <Button color="blue" variant="outlined" key="ok" onClick={handleOk}>
          บันทึก
        </Button>,
      ]}
    >
      <Spin spinning={loading} size="large" tip=" Loading... ">
        <Row>
          <Col span={"24"} style={{ textAlign: "center", marginBottom: 20 }}>
            <Space size={8} direction="herizental" style={{ marginRight: 10 }}>
              <Checkbox onChange={onChangeCheckbox}>
                นำเข้าไม่มีเงื่อนไข
              </Checkbox>
              <Input
                placeholder="ค้นหาสัญญา"
                onChange={(e) => onChangeInputSearch(e.target.value)}
                style={{ width: "100%", borderRadius: 8, marginBottom: 5 }}
                size="small"
                suffix={<span style={{ marginRight: 5 }}>👤</span>}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                }}
                onClick={queryData}
                disabled={loading}
              >
                ค้นหา
              </Button>
              <Button
                icon={<RestOutlined />}
                size="large"
                onClick={() => setArrayTable([])}
                type="default"
                danger
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.06)",
                  fontWeight: "bold",
                }}
                disabled={loading}
              >
                ล้างข้อมูลตาราง
              </Button>
            </Space>
          </Col>
        </Row>
        <Card>
          <Table
            style={{ marginTop: "10px" }}
            size="small"
            columns={columns}
            dataSource={arrayTable}
            scroll={{ x: 850 }}
            footer={() => <p>จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable.length}</p>}
          />
        </Card>
      </Spin>
    </Modal>
  );
};
export default AddInvestigate;
